import { render, staticRenderFns } from "./contact-manager.vue?vue&type=template&id=d9856734&"
import script from "./contact-manager.vue?vue&type=script&lang=js&"
export * from "./contact-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports